const toggleWithoutAnimation = state => state.app.sidebar.withoutAnimation
const config = state => state.app.config
const palette = state => state.app.config.palette
const isLoading = state => state.app.isLoading
const nuevaVenta = state => state.app.nuevaVenta
const proveedores = state => state.app.proveedores
const proveedor = ({app}) => (id) => app.proveedores.find(p => p.id === id)
const ordenCompra = state => state.app.ordenCompra
const authStatus = state => state.status
const isLoggedIn = state => !!state.token
const usuarios = state => state.app.usuarios
const usuario = ({app}) => (id) => app.usuarios.find(u => u.id === id)
const transportes = state => state.app.transportes
const productos = state => state.app.productos
const productoCriterio = state => state.app.productoCriterio
const marcas = state => state.app.marcas
const modelos = state => state.app.modelos
const categorias = state => state.app.categorias
const familias = state => state.app.familias
const vehiculos = state => state.app.vehiculos
const marcaProducto = state => state.app.marcaProducto
const clasificacion = state => state.app.clasificacion
const productoMiranda = state => state.app.productoMiranda
const preingresos = state => state.app.pre_ingresos
const clientes = state => state.app.cliente
const voucher = state => state.app.voucher
const productoVenta = state => state.app.productoVenta
const product = ({app}) => (id) => app.productoVenta.find(p => p.id === id)
const sucursales = state => state.app.sucursales
const sucursal = ({app}) => (id) => {
    const d = app.sucursales.find(s => s.id === id)
    return d || {nombre: "No encontrado"}
}
const boletas = state => state.app.boletas
const facturas = state => state.app.facturas
const nota_credito = state => state.app.nota_credito
const ingresos = state => state.app.ingresos
const encargos = state => state.app.encargos
const saldosFavor = ({ app }) => app.saldosFavor

export {
    toggleWithoutAnimation,
    config,
    palette,
    isLoading,
    nuevaVenta,
    proveedores,
    proveedor,
    ordenCompra,
    authStatus,
    isLoggedIn,
    usuarios,
    usuario,
    transportes,
    productos,
    productoCriterio,
    marcas,
    modelos,
    categorias,
    vehiculos,
    familias,
    marcaProducto,
    clasificacion,
    productoMiranda,
    preingresos,
    clientes,
    voucher,
    productoVenta,
    sucursales,
    sucursal,
    product,
    boletas,
    facturas,
    nota_credito,
    ingresos,
    encargos,
    saldosFavor
}
